<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <DrugInfo/>
    </div>
    <div class="col-6">
      <ConfirmFlow 
      v-if="currentProgress === 'confirm'"
      :confirmProgress="confirmProgress"
      :currentDrugInDeviceIndex="currentDrugInDeviceIndex"
      :startType="startType"
      v-on:confirmationFinish="getConfirmData"
      ></ConfirmFlow>    
      <Loader v-if="currentProgress === 'finish'" />
    </div>
  </div>
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import DrugInfo from '../flowComp/DrugInfo';
import SystemPanel from '../flowComp/SystemPanel';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';


export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  props: [
    'startType',
  ],
  data() {
    return {
    };
  },
  components: {
    DrugInfo,
    SystemPanel,
    ConfirmFlow,
    Loader,
  },
  created() {
    if (this.startType === 'createNewDrugStorage') {
      // nothing to do here.
    }
    if (this.startType === 'refill') {
      this.$store.dispatch('fromFirstDrugInDevice');
    }
  },
  methods: {
    async getConfirmData() {
      this.nextProgress();
      if (this.nextDrugInDevice !== null) {
        // check whether next index is over the keys' array length
        console.log('get confirm data');
        await this.$store.dispatch('toNextDrugInDevice');
        setTimeout(() => {
          this.resetProgress();
        }, 200);
        this.$store.commit('SET_CURRENT_STEP', 'setPatch');
      } else {
        console.log('leave multiflow');
        this.$emit('setAllConfirmData');
      }
    },
  },
  computed: {
    currentDrugInDeviceIndex() {
      return this.$store.state.drugInDevice.currentDrugInDeviceIndex;
    },
    selectedDrugInDevice() {
      return this.$store.state.drugInDevice.selectedDrugInDevice;
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?6adcf732